import { getSession, Session } from "@insite/client-framework/Services/SessionService";
import { BillToModel } from "@insite/client-framework/Types/ApiModels";

// get global for google tag manager
function getDataLayer() {
     return (window as any).dataLayer;
}
// get global for google analytics
function getGa() {
    return (window as any).ga;
}

let lastTrackedUrl = "";

export function pageView(breadcrumbs: any, pageType: any, userId: any, loginStatus: any, pageName: any, userSession: Session, currentBillTo: any) {
    if (IS_SERVER_SIDE) {
        return;
    }

    const url = window.location.pathname + window.location.search;
    if (url === lastTrackedUrl) {
        return;
    }

    lastTrackedUrl = url;

    const dataLayer = getDataLayer();

    let phoneNumber = "";
    if (userSession.properties?.phoneNumber && userSession.properties?.phoneNumber !== "") {
        phoneNumber = userSession.properties?.phoneNumber;
    }

    // 
    if (dataLayer) {
        dataLayer?.push({
            event: "pageView",
            page_name: pageName,
            page_breadcrumb: breadcrumbs,
            page_type: pageType,
            user_id: userSession?.userName ?? "",
            login_status: loginStatus,
            // user_email: userSession?.email ?? "",
            // user_phone_number: phoneNumber,
            // user_first_name: userSession?.firstName ?? "",
            // user_last_name: userSession?.lastName ?? "",
            // user_address: currentBillTo?.value?.fullAddress ?? "",
        });
    } else {
        const ga = getGa();
        if (ga) {
            ga("set", "location", url);
            ga("set", "page", window.location.pathname + window.location.search);
            ga("send", "pageview");
        }
    }
}

export function viewCart(ecommerce: any) {
    const dataLayer = getDataLayer();
    dataLayer?.push({ ecommerce: null }); // Clear previous ecommerce object
    dataLayer?.push(ecommerce);
}

export function beginCheckout(ecommerce: any) {
    const dataLayer = getDataLayer();
    dataLayer?.push({ ecommerce: null }); // Clear previous ecommerce object
    dataLayer?.push(ecommerce);
}

export function addShippingInfo(ecommerce: any) {
    const dataLayer = getDataLayer();
    dataLayer?.push({ ecommerce: null }); // Clear previous ecommerce object
    dataLayer?.push(ecommerce);
}

export function addPaymentInfo(ecommerce: any) {
    const dataLayer = getDataLayer();
    dataLayer?.push({ ecommerce: null }); // Clear previous ecommerce object
    dataLayer?.push(ecommerce);
}

export function purchase(ecommerce: any) {
    const dataLayer = getDataLayer();
    dataLayer?.push({ ecommerce: null }); // Clear previous ecommerce object
    dataLayer?.push(ecommerce);
}

export function addToCartEvent(ecommerce: any) {
    const dataLayer = getDataLayer();
    dataLayer?.push({ ecommerce: null });
    dataLayer?.push(ecommerce);
}

export function removeFromCartEvent(ecommerce: any) {
    const dataLayer = getDataLayer();
    dataLayer?.push({ ecommerce: null });
    dataLayer?.push(ecommerce);
}

export function viewItem(ecommerce: any) {
    const dataLayer = getDataLayer();
    dataLayer?.push({ ecommerce: null });
    dataLayer?.push(ecommerce);
}

export function selectItem(ecommerce: any) {
    const dataLayer = getDataLayer();
    dataLayer?.push({ ecommerce: null });
    dataLayer?.push(ecommerce);
}

export function applyPromoCode(ecommerce: any) {
    const dataLayer = getDataLayer();
    dataLayer?.push({ ecommerce: null });
    dataLayer?.push(ecommerce);
}

export function viewItemList(ecommerce: any) {
    const dataLayer = getDataLayer();
    dataLayer?.push({ ecommerce: null });
    dataLayer?.push(ecommerce);
}

export function viewPromotion(ecommerce: any) {
    const dataLayer = getDataLayer();
    dataLayer?.push({ ecommerce: null });
    dataLayer?.push(ecommerce);
}

export function userCreated(data: any) {
    const dataLayer = getDataLayer();
    dataLayer?.push(data);
}

export function userLoggedIn(data: any) {
    const dataLayer = getDataLayer();
    dataLayer?.push(data);
}

export function userLoggedOut(data: any) {
    const dataLayer = getDataLayer();
    dataLayer?.push(data);
}

export function formSubmission(ecommerce: any) {
    const dataLayer = getDataLayer();
    dataLayer?.push(ecommerce);
}

export function PdpPaginationChange(data: any) {
    const dataLayer = getDataLayer();
    dataLayer?.push(data);
}

export function navigationInteraction(data: any) {
    const dataLayer = getDataLayer();
    dataLayer?.push(data);
}

// EC-1433 DataLayer Tag for user_information
export function userInformation(userSession: Session, loginStatus: string, currentBillTo: BillToModel | null ) {
    const dataLayer = getDataLayer();
    dataLayer?.push({
        event: "user_information",
        login_status: loginStatus,
        user_email: userSession.email ?? "",
        user_phone_number: userSession.properties?.phoneNumber ?? "",
        user_first_name: userSession.firstName ?? "",
        user_last_name: userSession.lastName ?? "",
        user_address: currentBillTo?.fullAddress ?? "",
        user_id: userSession.userName ?? "",
    });
}

export function fireFormSubmissionSuccess(data: any){
    const dataLayer = getDataLayer() ;
    dataLayer?.push(data);
}

export function selectPromotion(data: any) {
    const dataLayer = getDataLayer();
    dataLayer?.push(data);
}